import { render, staticRenderFns } from "./WatchingBriefSection.vue?vue&type=template&id=3c65fea0&"
import script from "./WatchingBriefSection.vue?vue&type=script&lang=js&"
export * from "./WatchingBriefSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports